import React from "react";
import { t } from "../../../i18n";
import CustomButton from "../shared/CustomButton";
import InputKeyValue from "../shared/InputKeyValue";

const Login = (props) => {
  const { 
    client_logo: ClientLogo, 
    client, 
    login, 
    forgetPw 
  } = props;
  return (
    <div className="login">
      <div className="login__container">
        <div className="login__logo">
          <img className="login__logo-image" src={client.logo.url} alt="" />
        </div>
        <div className="login__header">
          <div className="login__title">Bem-vindo!</div>
          <div className="login__subtitle">
            Introduza o seu email e a palavra-passe para aceder à sua conta.
          </div>
        </div>
        <form className="login__form" id="login__form" onSubmit={login} > 
          <div className="login__form-email">
            <InputKeyValue
              title={"Login ou email"}
              placeholder={"Inserir login ou email"}
              name="email"
              type="text"
              required
            />
          </div>
          <div className="login__form-password">
            <InputKeyValue
              title={"Palavra-passe"}
              placeholder={"Inserir a sua palavra-passe"}
              name="password"
              type="password"
              required
            />
          </div>
          <div className="login__form-forgot-password">
            <CustomButton className="login__form-forgot-password-link" link tight to={forgetPw}>
              {t("gamification2026.login.forgot-password")}
            </CustomButton>
          </div>
        </form>
        <div className="login__actions">
          <CustomButton className="login__actions-button" primary form="login__form" type="submit">
            {t("gamification2026.login.submit")}
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default Login;
